import { render, staticRenderFns } from "./DateModalChannels.vue?vue&type=template&id=37a48a67&scoped=true&"
import script from "./DateModalChannels.vue?vue&type=script&lang=js&"
export * from "./DateModalChannels.vue?vue&type=script&lang=js&"
import style0 from "./DateModalChannels.vue?vue&type=style&index=0&id=37a48a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a48a67",
  null
  
)

export default component.exports